import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { DeliveryAreaService } from '../../../../../delivery-area.service';
import { SpecialistFeedback } from '../specialist-feedback-view.part';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, areaService: DeliveryAreaService): GridSetup<SpecialistFeedback> {

	const staffPermissions = areaService.staffPermissions();

	return {
		rowName: { singular: 'Specialist Feedback', plural: 'Specialist Feedbacks' },
		getRowKey: row => '' + row.accSessionSpecialistSurveyResponseId,
		stateKey: 'delivery-specialist-feedback-grid',
		actions: [],
		buttons: [],
		columns: getColumns(util),
		downloadOptions: {
			canDownload: staffPermissions.canDownloadProgramData,
			canDownloadPersonalInfo: staffPermissions.canDownloadProgramDataWithPersonalInfo,
			fileName: `${areaService.selectedTrimesterName()}-Specialist-Feedbacks`
		}
	}
}
